interface StatusErrorArgs {
  status: number;
  pathname: string;
  message: string;
}

export const errorStatuses = {
  BAD_REQUEST_ERROR: 400,
  UNAUTHORIZED_ERROR: 401,
  FORBIDDEN_ERROR: 403,
  NOT_FOUND_ERROR: 404,
  TOO_MANY_REQUESTS_ERROR: 429,
  SERVER_ERROR: 500,
  NOT_IMPLEMENTED_ERROR: 501,
  BAD_GATEWAY_ERROR: 502,
  NETWORK_ERROR: 503,
};
export default class StatusError extends Error {
  status: number;
  pathname: string;

  constructor({ message, status, pathname }: StatusErrorArgs) {
    super(message);

    // Fix prototype chain for proper instanceof behavior in Jest
    Object.setPrototypeOf(this, StatusError.prototype);

    this.status = status;
    this.pathname = pathname;
  }

  public isBadRequestError = (): boolean => {
    return this.status === errorStatuses.BAD_REQUEST_ERROR;
  };

  public isUnauthorizedError = (): boolean => {
    return this.status === errorStatuses.UNAUTHORIZED_ERROR;
  };

  public isForbiddenError = (): boolean => {
    return this.status === errorStatuses.FORBIDDEN_ERROR;
  };

  public isNotFoundError = (): boolean => {
    return this.status === errorStatuses.NOT_FOUND_ERROR;
  };

  public isTooManyRequestsError = (): boolean => {
    return this.status === errorStatuses.TOO_MANY_REQUESTS_ERROR;
  };

  public isServerError = (): boolean => {
    return this.status === errorStatuses.SERVER_ERROR;
  };

  public isNotImplementedError = (): boolean => {
    return this.status === errorStatuses.NOT_IMPLEMENTED_ERROR;
  };

  public isBadGatewayError = (): boolean => {
    return this.status === errorStatuses.BAD_GATEWAY_ERROR;
  };

  public isNetworkError = (): boolean => {
    return this.status === errorStatuses.NETWORK_ERROR;
  };
}

const getMessageFromResponse = async (response: Response): Promise<string> => {
  const text = await response.text();
  try {
    const data = JSON.parse(text);
    return data?.message ?? '';
  } catch (_ex) {
    return text;
  }
};

export const createStatusError = async (
  pathname: string,
  response: Response,
) => {
  const message = await getMessageFromResponse(response);
  return new StatusError({
    message,
    status: response.status,
    pathname,
  });
};
